<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { useAuth } from '@clerk/vue'
import { onMounted, computed } from 'vue'
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
import CookieConsent from './components/CookieConsent.vue'

const { isLoaded } = useAuth()
const route = useRoute()

// Only show cookie consent on the homepage
const showCookieConsent = computed(() => {
  return route.path === '/'
})

// Hide footer on game room routes to maximize game viewport
const showFooter = computed(() => {
  return !route.path.startsWith('/room/')
})

onMounted(() => {
  console.log('[Stack25] App mounted, Clerk isLoaded:', isLoaded.value)
})
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <template v-if="isLoaded">
      <NavBar />
      <div class="flex-1">
        <RouterView />
      </div>
      <Footer v-if="showFooter" />
      <CookieConsent v-if="showCookieConsent" />
    </template>
    <template v-else>
      <div class="flex items-center justify-center min-h-screen">
        <div class="text-center">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p class="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    </template>
  </div>
</template>
